import { render, staticRenderFns } from "./chooselocation.vue?vue&type=template&id=34d048c2&scoped=true"
import script from "./chooselocation.vue?vue&type=script&lang=js"
export * from "./chooselocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d048c2",
  null
  
)

export default component.exports